class StickyLpCta extends HTMLElement {
  constructor() {
    super();
    document.addEventListener('DOMContentLoaded', () => this.init());
  }

  init() {
    this.heroVisible = true;
    this.pastScroll = false;

    this.hero = document.querySelector('.listicle-hero') ||
                document.querySelector('[class*="hero"]') ||
                document.querySelector('#shopify-section-listicle_hero');
    if (!this.hero) {
      this.heroVisible = false;
    } else {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.heroVisible = entry.isIntersecting;
          this.update();
        });
      }, { threshold: 0 }).observe(this.hero);
    }

    window.addEventListener('scroll', () => {
      var doc = document.documentElement;
      var pct = (window.pageYOffset + window.innerHeight) / Math.max(doc.scrollHeight, 1) * 100;
      this.pastScroll = pct >= 90;
      this.update();
    }, { passive: true });

    this.update();
  }

  update() {
    if (!this.heroVisible && !this.pastScroll) {
      this.classList.add('active');
    } else {
      this.classList.remove('active');
    }
  }
}

customElements.define('sticky-lp-cta', StickyLpCta);
